import UI from  "./ui.js";

/* sets up root path for webpack dynamic imports  */
__webpack_public_path__ = window['_root'];

class App {	
    constructor() {
        this.ui = new UI(this);
    }
}
export default new App();